/** Route an anonymous viewer to sign-up, returning to the current page after. */
export function gotoSignUp(): void {
    const destinationPath = encodeURIComponent(window.location.pathname + window.location.search);
    window.location.href = `/signup?destinationPath=${destinationPath}`;
}
